<!--Select Mode-->
<div class="ModeBorder">
	<div class="ModeGrid">
		<h4>Mode:</h4>

		<select class="form-control" name="SelectModeID" [(ngModel)]="SelectModeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSelectMode" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>
	</div>
</div>

<!--Person Mode (Normal)-->
<div *ngIf="SelectModeID == 0">
	<caass-student-pbis-person-mode></caass-student-pbis-person-mode>
</div>

<!--Group Mode-->
<div *ngIf="SelectModeID == 1">
	<caass-student-pbis-group-mode></caass-student-pbis-group-mode>
</div>
